<template>
  <div class="page-content conmon-top">
    <el-row class="common-table-top">
      <el-button type="primary" @click="goToActivity">活动管理</el-button>
      <el-button type="primary" @click="goToTopic">题库管理</el-button>
    </el-row>
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchLoad">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide" class="search-content common-search-formtype">
          <el-form :inline="true" :model="formInlineTmp" label-width="95px" class="search-content-item">
            <el-form-item label="题面:">
              <el-input v-model.trim="formInlineTmp.question" placeholder="请输入活动名称" clearable ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-button type="primary" @click="add" class="add-btn btn-right" style="float: right;">添加</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table
        :data="tableData"
        v-loading="loading"
        class="table">
        <el-table-column
          prop="question"
          label="题面">
        </el-table-column>
        <el-table-column
          prop="answer1"
          label="选项1">
        </el-table-column>
        <el-table-column
          prop="answer2"
          label="选项2">
        </el-table-column>
        <el-table-column
          prop="answer3"
          label="选项3">
        </el-table-column>
        <el-table-column
          width='80'
          prop="okanswer"
          label="答案">
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <div class="op-link" @click="edit(scope.row)">
                编辑
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination
          class="table-foot-pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
      <!--添加弹窗-->
      <el-dialog class="cellDialog base-dialog" title="添加题面" :visible.sync="showAdd" width="550px">
        <el-form :rules="rules" ref="addForm" :model="addForm" class="newMessageForm">
          <el-form-item label="题面:" :label-width="addLabelWidth" prop="question">
            <el-input  v-model.trim="addForm.question" class="stockInput" type="text"></el-input>
          </el-form-item>
          <el-form-item label="选项1:" :label-width="addLabelWidth" prop="answer1">
            <el-input  v-model.trim="addForm.answer1" class="stockInput" type="text"></el-input>
          </el-form-item>
          <el-form-item label="选项2:" :label-width="addLabelWidth" prop="answer2">
            <el-input  v-model.trim="addForm.answer2" class="stockInput" type="text"></el-input>
          </el-form-item>
          <el-form-item label="选项3:" :label-width="addLabelWidth" prop="answer3">
            <el-input  v-model.trim="addForm.answer3" class="stockInput" type="text"></el-input>
          </el-form-item>
          <el-form-item label="正确答案:" :label-width="addLabelWidth" prop="okanswer">
            <el-input  v-model.trim="addForm.okanswer" class="stockInput" type="text"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="margin-top: 10px">
          <el-button class="dialog-cancel-btn" @click="showAdd = false" style="margin-left: 20px">取 消</el-button>
          <el-button class="dialog-confirm-btn save-check-btn" style="margin-right: 32px" type="primary" @click="addSubmit()">添加</el-button>
        </div>
      </el-dialog>
      <!--编辑弹窗-->
      <el-dialog class="cellDialog base-dialog" title="编辑题面" :visible.sync="showEdit" width="550px">
        <el-form :rules="rules" ref="editForm" :model="editForm" class="newMessageForm">
          <el-form-item label="题面:" :label-width="addLabelWidth" prop="question">
            <el-input  v-model.trim="editForm.question" class="stockInput" type="text"></el-input>
          </el-form-item>
          <el-form-item label="选项1:" :label-width="addLabelWidth" prop="answer1">
            <el-input  v-model.trim="editForm.answer1" class="stockInput" type="text"></el-input>
          </el-form-item>
          <el-form-item label="选项2:" :label-width="addLabelWidth" prop="answer2">
            <el-input  v-model.trim="editForm.answer2" class="stockInput" type="text"></el-input>
          </el-form-item>
          <el-form-item label="选项3:" :label-width="addLabelWidth" prop="answer3">
            <el-input  v-model.trim="editForm.answer3" class="stockInput" type="text"></el-input>
          </el-form-item>
          <el-form-item label="正确答案:" :label-width="addLabelWidth" prop="okanswer">
            <el-input  v-model.trim="editForm.okanswer" class="stockInput" type="text"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="margin-top: 10px">
          <el-button class="dialog-cancel-btn" @click="showEdit = false" style="margin-left: 20px">取 消</el-button>
          <el-button class="dialog-confirm-btn save-check-btn" style="margin-right: 32px" type="primary" @click="editSubmit()">保存</el-button>
        </div>
      </el-dialog>
    </el-row>
  </div>
</template>
<script>
import { getGuessRiddlesTopicList, editGuessRiddlesTopic, createGuessRiddlesTopic, getGuessRiddlesTopicDetail } from '@/api/customer.js'
export default {
  name: 'activityTopicList',
  data () {
    return {
      loading: true,
      showAdd: false,
      showEdit: false,
      hide: true,
      addLabelWidth: '80px',
      tableData: [],
      page: 1,
      totalCount: 0,
      formInlineTmp: {
        question: ''
      },
      rules: {
        question: [
          { required: true, message: '请输入题面', trigger: 'blur' }
        ],
        answer1: [
          { required: true, message: '请输入选项', trigger: 'blur' }
        ],
        answer2: [
          { required: true, message: '请输入选项', trigger: 'blur' }
        ],
        answer3: [
          { required: true, message: '请输入选项', trigger: 'blur' }
        ],
        okanswer: [
          { required: true, message: '请输入答案', trigger: 'blur' }
        ]
      },
      addForm: {
        question: '',
        answer1: '',
        answer2: '',
        answer3: '',
        okanswer: ''
      },
      editForm: {
        question: '',
        answer1: '',
        answer2: '',
        answer3: '',
        okanswer: ''
      },
      qrCodeUrl: '',
      limit: 10
    }
  },
  methods: {
    goToActivity() {
      this.$router.push('/home/guess-riddles-activity')
    },
    goToTopic() {
      this.$router.push('/home/guess-riddles-topic')
    },
    add() {
      this.showAdd = true
    },
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          createGuessRiddlesTopic(this.addForm).then(res => {
            if (res.data.code === 0) {
              _g.toastMsg('success', res.data.error)
              this.showAdd = false
              this.getData()
            } else {
              _g.toastMsg('error', res.data.error)
            }
          })
        } else {
          return false
        }
      })
    },
    edit(form) {
      this.showEdit = true
      this.editForm = form
    },
    editSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          editGuessRiddlesTopic(this.editForm.id, this.editForm).then(res => {
            if (res.data.code === 0) {
              _g.toastMsg('success', res.data.error)
              this.showEdit = false
            } else {
              _g.toastMsg('error', res.data.error)
            }
          })
        } else {
          return false
        }
      })
    },
    searchLoad() {
      this.page = 1
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.getData()
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
    },
    handleCurrentChange(page) {
      console.log('handleCurrentChangethis.formInline', this.formInline)
      this.page = page
      this.getData()
    },
    copyAcivityAction(id) {
      copyAcivity(id).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          this.getData()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    getData() {
      this.loading = true
      getGuessRiddlesTopicList(this.page, this.formInline).then(res => {
        this.tableData = res.data.data.list
        this.totalCount = res.data.data.count
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  created() {
    this.getData()
  },
  components: {
  }
}
</script>

<style scoped>
  .sign-manage-title {
    height:40px;
  }
  .content-one span {
    display: inline-block;
    float: left;
    line-height: 20px;
    font-size: 16px;
    margin-top: 10px;
  }
  .content-one p {
    text-align: left;
  }
</style>
